<template>
  <v-card>
    <v-card-title>
      <v-icon :color="atRisk ? 'error' : 'success'" class="me-2">
        {{ atRisk ? 'mdi-alert-outline' : 'mdi-check-circle-outline' }}
      </v-icon>
      {{ $t('schools_at_risk') }}
      <v-spacer></v-spacer>
      <v-chip v-if="atRisk" small color="error" dark>{{ atRisk }}</v-chip>
      <v-btn icon :loading="isLoading" @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>{{ $t('schools_at_risk_hint') }}</v-card-subtitle>

    <v-card-text>
      <vue-element-loading :active="isLoading" />

      <p v-if="!isLoading && !atRisk" class="mb-0">{{ $t('every_school_is_running') }}</p>

      <v-simple-table v-else dense>
        <template #default>
          <thead>
            <tr>
              <th>{{ $t('school') }}</th>
              <th class="text-end">{{ $t('students') }}</th>
              <th class="text-end">{{ $t('mapped') }}</th>
              <th class="text-end">{{ $t('runs_today') }}</th>
              <th class="text-end">{{ $t('days_left') }}</th>
              <th>{{ $t('what_is_wrong') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="school in troubled" :key="school.id">
              <td class="text-no-wrap">{{ school.name }}</td>
              <td class="text-end">{{ school.students }}</td>
              <td class="text-end">{{ school.mapped }}</td>
              <td class="text-end">
                <span :class="school.runs_today === 0 ? 'error--text font-weight-bold' : ''">
                  {{ school.runs_today }}
                </span>
              </td>
              <td class="text-end">
                <span v-if="school.days_left !== null" :class="school.days_left <= 3 ? 'error--text' : ''">
                  {{ school.days_left }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                <v-chip
                  v-for="problem in school.problems"
                  :key="problem"
                  x-small
                  outlined
                  :color="problem === 'no_runs_today' ? 'error' : 'warning'"
                  class="me-1 my-1"
                >
                  {{ $t('risk_' + problem) }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
/*
 * Which schools are about to have a bad morning.
 *
 * The admin dashboard counted schools, students and drivers - which says how
 * big the platform is and nothing about whether it is working. A school whose
 * buses are not published today, whose coins run out on Thursday, or half of
 * whose children were never mapped was invisible until it telephoned, and by
 * then it was the platform's problem too.
 *
 * Schools that are fine are not listed. A table of thirty rows where two matter
 * is a table nobody reads.
 */
import VueElementLoading from "vue-element-loading";

export default {
  name: "SchoolsAtRisk",
  components: { VueElementLoading },
  data() {
    return {
      schools: [],
      atRisk: 0,
      isLoading: false,
    };
  },
  computed: {
    troubled() {
      return this.schools.filter((school) => school.problems && school.problems.length);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.isLoading = true;
      axios
        .get("/admin-dashboard/schools-at-risk")
        .then((response) => {
          this.schools = response.data.schools || [];
          this.atRisk = response.data.at_risk || 0;
        })
        .catch(() => {
          //a dashboard card must not take the dashboard down with it
          this.schools = [];
          this.atRisk = 0;
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
